import { render, staticRenderFns } from "./handbiezhu.vue?vue&type=template&id=20cd6272"
import script from "./handbiezhu.vue?vue&type=script&lang=js"
export * from "./handbiezhu.vue?vue&type=script&lang=js"
import style0 from "./handbiezhu.vue?vue&type=style&index=0&id=20cd6272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports